// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ac88854","453":"30ec8944","732":"2df34e2e"}[chunkId] + ".chunk.js";
};